import UserDashboard from ".";

export const userDashboardRoutes = () => [
  {
    path: "/user/dashboard",
    component: UserDashboard,
    layout: "user",
    routeType: "user",
    title: "User Dashboard Management",
  },
];